export default __webpack_public_path__ + "static/media/Backgound with gradients.3fdef007.png";